import * as turf from '@turf/turf';

export const filterPointsInArea = (feature: any, points: any[]) => {
  const radius = feature.properties.circleRadius;

  return points.filter(loc => {
    const pt = turf.point([loc.lon, loc.lat]);

    if (radius && radius > 0) {
      const centerCoords = feature.geometry.coordinates[0][0];
      const center = turf.point(centerCoords);
      const distance = turf.distance(center, pt, { units: 'kilometers' });
      return distance <= radius;
    }
    else {
      return turf.booleanPointInPolygon(pt, feature);
    }
  });
};
